import { Link } from 'react-router-dom';

import { Button, Card, Col, Flex, Row, Spin, Tag, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { formatDate } from 'helpers/date';
import TopPage from 'v2/components/Shared/TopPage';
import { useNewzzList } from 'v2/hooks/useNewzz';
import type { Newzz } from 'v2/services/newzz';

const NewzzList = () => {
  const { canLoadMore, newzz, clickNewzz, isLoading, loadMore, isFetching } = useNewzzList();

  return (
    <div className='w-full'>
      <TopPage title='Newzz' extra='Fique por dentro de todas as novidades da Eduzz' />

      <div>
        <Row justify='center' align='middle'>
          <Col xs={24} md={16} lg={16}>
            {newzz.map((item, index) => (
              <div key={`panel-${index}`} className='animate-slideUp'>
                {item.has_content ? (
                  <Link onClick={() => clickNewzz(item.id)} to={`/producer/news/info/${item.id}`}>
                    <NewzzItem item={item} />
                  </Link>
                ) : (
                  <a
                    onClick={() => clickNewzz(item.id)}
                    href={item.external_url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <NewzzItem item={item} />
                  </a>
                )}
              </div>
            ))}
          </Col>
          {canLoadMore && (
            <Col xs={24} md={16} lg={16} className='text-center'>
              <Button disabled={isLoading} onClick={() => loadMore()} loading={isFetching} icon={<Icon.ChevronDown  />}>
                Carregar mais
              </Button>
            </Col>
          )}
          {isLoading && <Spin />}
        </Row>
      </div>
    </div>
  );
};

const NewzzItem = ({ item }: { item: Newzz }) => (
  <Card hoverable size='small' className='mb-2'>
    <Flex align='center' justify='space-between' gap='small'>
      <Typography.Text strong>{item.title}</Typography.Text>
      <Flex align='center' gap='small'>
        {item.show_tag_new && <Tag color='success'>NOVO</Tag>}
        <Typography.Text type='secondary'>{formatDate(item.created_at, 'dd/MM/yyyy')}</Typography.Text>
      </Flex>
    </Flex>
  </Card>
);

export default NewzzList;
